import { useCallback, useEffect, useState } from "react";

import { useGlobalsContext } from "shared/hooks";
import replaceVariablesInString from "shared/utils/replaceVariablesInString";

function useFormattedWelcomeMessage(initialVal: string) {
  const [formattedWelcomeMessage, setFormattedWelcomeMessage] = useState("");

  const { variables } = useGlobalsContext();

  const updateWelcomeMessage = useCallback(() => {
    setFormattedWelcomeMessage(
      replaceVariablesInString(initialVal, variables) ||
        "Could not load formatted welcome message cause finalVal is empty",
    );
  }, [initialVal, variables]);

  useEffect(() => {
    if (initialVal) {
      updateWelcomeMessage();
    }
  }, [initialVal, updateWelcomeMessage, variables]);

  return { formattedWelcomeMessage, setFormattedWelcomeMessage };
}

export default useFormattedWelcomeMessage;
